import { createDataPointProcessor } from "../utils/dataPointProcessor";
import { applyLineGraphState } from "../utils/lineGraphState";
import {
  initializeDictionaries,
  initializeEmotionDict,
  initializeActionDictionaries,
} from "../utils/dictionaries";
import {
  transform,
  transformActions,
  transformStudentSupportData,
  transformAllActions,
  computeParticipationPercentChange,
} from "../utils/transformers";
import {
  processAllDistricts,
  processAllSchoolsInDistrict,
  processSpecificSchool,
} from "../utils/processSchools";
import {
  processSpecificClass,
  processSpecificStudent,
} from "../utils/processClasses";
import moment from "moment";

export function handleMultiEmotion(state, allEmotions = []) {
  const { currentDict, compareDict } = initializeDictionaries();
  const { currentActionDict, compareActionDict } =
    initializeActionDictionaries();
  const currentParticipants = new Set();
  const compareParticipants = new Set();
  let impactfulActions = { action: {}, emotion: {} };
  let updateState = {};
  let filterDataPoints = [];
  let studentEmotionData = {};
  let studentSupportData = {};
  const bigFiveFilteredData = [];
  const lineGraphSourceData = [];
  const contextFilteredDataPoints = [];
  let tooltipCounts = initializeEmotionDict();
  const now = moment();
  const currentDate = moment().subtract(state.filterAmountCurrent);
  const compareDate = moment().subtract(
    state.filterAmountCurrent + state.filterAmountCompare
  );

  const processDataPoint = createDataPointProcessor(
    currentDate,
    compareDate,
    now,
    state.chosenEmotion,
    currentDict,
    compareDict,
    currentActionDict,
    compareActionDict,
    impactfulActions,
    filterDataPoints,
    studentEmotionData,
    studentSupportData,
    bigFiveFilteredData,
    state.selectedTimes,
    state.selectedSubOptions,
    state.helpfulFilter,
    tooltipCounts,
    currentParticipants,
    compareParticipants,
    allEmotions,
    lineGraphSourceData
  );

  if (state?.chosenDistrict === "All Districts") {
    processAllDistricts(state, processDataPoint);
  } else if (state?.chosenSchool === "All Schools") {
    processAllSchoolsInDistrict(state, processDataPoint);
  } else if (state?.chosenClass === "All Classes") {
    processSpecificSchool(state, state.chosenSchool, processDataPoint);
  } else if (state?.chosenStudent === "All Students") {
    processSpecificClass(state, state.chosenClass, processDataPoint);
  } else {
    processSpecificStudent(state, state.chosenStudent, processDataPoint);
  }

  updateState.filteredDataPoints = filterDataPoints;
  updateState.bigFiveFilteredData = bigFiveFilteredData.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );
  applyLineGraphState(updateState, lineGraphSourceData, state.chosenTime, now);
  updateState.contextFilteredDataPoints = contextFilteredDataPoints;

  transformStudentSupportData(
    studentSupportData,
    state.chosenPercentage,
    updateState
  );

  transform(currentDict, compareDict, updateState);
  transformActions(impactfulActions, updateState);
  transformAllActions(currentActionDict, compareActionDict, updateState);
  computeParticipationPercentChange(
    currentParticipants,
    compareParticipants,
    updateState
  );

  return updateState;
}
